<script lang="ts">
  import RadioGroup from "../../../components/RadioGroup.svelte";
  import CloseButton from "../../../components/CloseButton.svelte";
  import { type Component } from "svelte";

  let {
    answer,
    back,
    inactive,
    clientAddress,
    financeAgreementStartDateLocalized,
    nextSteps,
  }: {
    answer: ({ nextStep, status }) => void;
    back: () => void | null;
    inactive: boolean;
    clientAddress: { [key: string]: string };
    financeAgreementStartDateLocalized: string;
    nextSteps: { [key: string]: Component };
  } = $props();

  let selectedOption = $state(null);

  function handleContinue() {
    if (selectedOption === "unchanged") {
      answer({ nextStep: nextSteps.next, status: selectedOption })
    } else if (selectedOption === "changed") {
      answer({ nextStep: nextSteps.change, status: selectedOption });
    }
  }
</script>

<fieldset class="h-full">
  <legend class="mb-1.5">
    <p class="mb-2">
      Did you live at the following address on
      <b>{financeAgreementStartDateLocalized}</b>?
    </p>

    <div class="font-medium flex flex-col gap-1">
      <div>{clientAddress.street}</div>
      <div>
        {clientAddress.city}
        <span class="whitespace-nowrap">{clientAddress.postal_code}</span>
      </div>
    </div>
  </legend>

  <RadioGroup
    name="client_address[status]"
    options={[
      ["Yes", "unchanged"],
      ["No, my address was different back then", "changed"],
    ]}
    bind:group={selectedOption}
  />
</fieldset>

<div class="floating-footer">
  {#if back}
    <button type="button" class="btn btn-ghost" onclick={back}>Back</button>
  {:else}
    <CloseButton />
  {/if}
  <button
    type="submit"
    class="btn btn-primary"
    onclick={handleContinue}
    disabled={!selectedOption || inactive}>Continue</button
  >
</div>
